@if (hasSoundPressureLevel()) {
    <device-card-soundpressure
        class="emma-card auto-width"
        [device]="device"
        [showDeviceLink]="false"
        [editGraphViews]="true"
    ></device-card-soundpressure>
}
@if (hasSoundPressureLevelC()) {
    <device-card-soundpressure
        class="emma-card auto-width"
        [device]="device"
        [dataType]="DataTypeModelKey.soundPressureLevelC"
        [showDeviceLink]="false"
        [editGraphViews]="true"
    ></device-card-soundpressure>
}
@if (hasSoundPressureLevel1Minute()) {
    <device-card-soundpressure
        class="emma-card auto-width"
        [device]="device"
        [dataType]="DataTypeModelKey.soundPressureLevel1Minute"
        [showDeviceLink]="false"
        [editGraphViews]="true"
    ></device-card-soundpressure>
}
@if (hasSoundPressureLevel1MinuteSensor2()) {
    <device-card-soundpressure
        class="emma-card auto-width"
        [device]="device"
        [dataType]="DataTypeModelKey.soundPressureLevel1MinuteSensor2"
        [showDeviceLink]="false"
        [editGraphViews]="true"
    ></device-card-soundpressure>
}
@if (hasSoundPressureLevelC1Minute()) {
    <device-card-soundpressure
        class="emma-card auto-width"
        [device]="device"
        [dataType]="DataTypeModelKey.soundPressureLevelC1Minute"
        [showDeviceLink]="false"
        [editGraphViews]="true"
    ></device-card-soundpressure>
}
@if (hasSoundPressureLevelCMinusA()) {
    <device-card-soundpressure
        class="emma-card auto-width"
        [device]="device"
        [dataType]="DataTypeModelKey.soundPressureLevelCMinusA"
        [showDeviceLink]="false"
        [editGraphViews]="true"
    ></device-card-soundpressure>
}
@if (hasRolling5()) {
    <device-card-soundpressure
        class="emma-card auto-width"
        [device]="device"
        [dataType]="DataTypeModelKey.rolling5"
        [showDeviceLink]="false"
        [showAvg5]="false"
        [showAvg30]="false"
        [editGraphViews]="true"
    ></device-card-soundpressure>
}
@if (hasRolling5C()) {
    <device-card-soundpressure
        class="emma-card auto-width"
        [device]="device"
        [dataType]="DataTypeModelKey.rolling5C"
        [showDeviceLink]="false"
        [showAvg5]="false"
        [showAvg30]="false"
        [editGraphViews]="true"
    ></device-card-soundpressure>
}
@if (hasRolling30()) {
    <device-card-soundpressure
        class="emma-card auto-width"
        [device]="device"
        [dataType]="DataTypeModelKey.rolling30"
        [showDeviceLink]="false"
        [showAvg5]="false"
        [showAvg30]="false"
        [editGraphViews]="true"
    ></device-card-soundpressure>
}
@if (hasRolling30C()) {
    <device-card-soundpressure
        class="emma-card auto-width"
        [device]="device"
        [dataType]="DataTypeModelKey.rolling30C"
        [showDeviceLink]="false"
        [showAvg5]="false"
        [showAvg30]="false"
        [editGraphViews]="true"
    ></device-card-soundpressure>
}
@if (hasRolling5s()) {
    <device-card-soundpressure
        class="emma-card auto-width"
        [device]="device"
        [dataType]="DataTypeModelKey.rolling5s"
        [showDeviceLink]="false"
        [showAvg5]="false"
        [showAvg30]="false"
        [editGraphViews]="true"
    ></device-card-soundpressure>
}
@if (hasRolling5sC()) {
    <device-card-soundpressure
        class="emma-card auto-width"
        [device]="device"
        [dataType]="DataTypeModelKey.rolling5sC"
        [showDeviceLink]="false"
        [showAvg5]="false"
        [showAvg30]="false"
        [editGraphViews]="true"
    ></device-card-soundpressure>
}
@if (hasSpectrum()) {
    <device-band-spectra class="emma-card auto-width" [device]="device" [showDeviceLink]="false" [editGraphViews]="true">
    </device-band-spectra>
}
@if (hasSpectrum1Minute()) {
    <device-band-spectra
        class="emma-card auto-width"
        [device]="device"
        [dataType]="DataTypeModelKey.spectrum13Octave1Minute"
        [showDeviceLink]="false"
        [editGraphViews]="true"
    >
    </device-band-spectra>
}
@if (hasBattery()) {
    <device-card-battery class="emma-card auto-width" [device]="device" [showDeviceLink]="false" [editGraphViews]="true">
    </device-card-battery>
}
@if (hasCellular()) {
    <device-card-cellular class="emma-card auto-width" [device]="device" [showDeviceLink]="false" [editGraphViews]="true">
    </device-card-cellular>
}
@if (hasFreeStorage()) {
    <device-card-free-storage class="emma-card auto-width" [device]="device" [showDeviceLink]="false" [editGraphViews]="true">
    </device-card-free-storage>
}
